import { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';

//import { setArchivedEvents } from './store/actions/eventsHistory';
// import { isObjectsEqual } from 'libs/common';
import { setEvent, setEventsList, setUnrecognized } from 'store/actions/events';
import { addWidget, removeWidget } from 'store/actions/widgets';
import { openWindow, closeWindows } from 'store/actions/windows';
import { setCallActive, setCall, dropCall } from 'store/actions/calls';
import { updateStatus, updateStatusBg } from 'store/actions/equipment';
import { setBoardsData } from 'store/actions/boards';
import { setCounters } from 'store/actions/counters';
import { getNodeTitle } from 'services/getNodeTitle';
import { AppSocket } from './app-socket';
import { PageMainView } from './page-main-view';
import { setOnetime, setRegular } from 'store/actions/windows';

let appSocket;

export const PageMain = () => {
  const calls = useSelector((store) => store.calls.calls, shallowEqual);
  const unrecognized = useSelector((store) => store.events.unrecognized, shallowEqual);
  const dispatch = useDispatch();
  const [ready, setReady] = useState(false);

  // init
  useEffect(() => {
    // load active calls from localstorage ??
    window.loadActiveCalls();

    // set initial vars
    dispatch(setOnetime(window.config.onetime_counters));
    dispatch(setRegular(window.config.regular_counters));

    // init socket
    initSocket();

    // open windows
    checkOpenWindows();

    // ready
    setReady(true);
  }, []);

  const doSetEvent = useCallback((...args) => dispatch(setEvent(...args)), [dispatch]);
  const doSetCallActive = useCallback((...args) => dispatch(setCallActive(...args)), [dispatch]);
  const doAddWidget = useCallback((...args) => dispatch(addWidget(...args)), [dispatch]);
  const doRemoveWidget = useCallback((...args) => dispatch(removeWidget(...args)), [dispatch]);
  const doOpenWindow = useCallback((...args) => dispatch(openWindow(...args)), [dispatch]);
  const doSetCall = useCallback((...args) => dispatch(setCall(...args)), [dispatch]);
  const doDropCall = useCallback((...args) => dispatch(dropCall(...args)), [dispatch]);
  const doUpdateStatus = useCallback((...args) => dispatch(updateStatus(...args)), [dispatch]);
  const doUpdateStatusBg = useCallback((...args) => dispatch(updateStatusBg(...args)), [dispatch]);
  const doSetEventsList = useCallback((...args) => dispatch(setEventsList(...args)), [dispatch]);
  const doSetBoardsData = useCallback((...args) => dispatch(setBoardsData(...args)), [dispatch]);
  const doSetUnrecognized = useCallback((...args) => dispatch(setUnrecognized(...args)), [dispatch]);
  const doCloseWindows = useCallback((...args) => dispatch(closeWindows(...args)), [dispatch]);
  const doSetCounters = useCallback((...args) => dispatch(setCounters(...args)), [dispatch]);

  // update
  useEffect(() => {
    // if (!isObjectsEqual(this.props.calls, prevProps.calls) || notEqual(this.props.unrecognized, prevProps.unrecognized)) {
    appSocket.update(calls, unrecognized);
  }, [calls, unrecognized]);

  /**
   * init socket
   */
  const initSocket = () => {
    const params = {
      // data
      calls,
      unrecognized,
      // actions
      doSetEvent,
      doSetCallActive,
      doAddWidget,
      doRemoveWidget,
      doOpenWindow,
      doSetCall,
      doDropCall,
      doUpdateStatus,
      doUpdateStatusBg,
      doSetEventsList,
      doSetBoardsData,
      doSetUnrecognized,
      doCloseWindows,
      doSetCounters,
    };
    appSocket = new AppSocket(params);
  };

  /**
   * check for open windows by external params
   */
  const checkOpenWindows = () => {
    // rack
    if (window.rack_id) {
      const node = window.config.nodes[window.rack_id];
      if (node) {
        const title = getNodeTitle(node.type, node.id, node.caption);
        doOpenWindow({
          id: node.id,
          type: 'rack',
          data: {
            id: node.id,
            type: node.type,
            barriersCount: node.barriersCount,
          },
          header: title,
        });
      }
      window.rack_id = null;
    }

    // zone
    if (window.zone_id) {
      const node = window.config.objects.zones.find((item) => {
        return item.zoneId.toString() === window.zone_id.toString();
      });
      //console.log('node',node);
      if (node) {
        doOpenWindow({
          id: '0',
          type: 'single_board',
          data: { zoneId: node.zoneId, color: node.color },
        });
      }
      window.zone_id = null;
    }

    // test
    // this.props.openWindow({
    //   id: 'calls',
    //   type: 'calls',
    //   data: {},
    //   header: '',
    // });
    // this.props.addWidget('activeCall');
  };

  // render
  if (!ready) {
    return null;
  }
  return <PageMainView unrecognized={unrecognized} />;
};
